export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_PAYMENT_CHANNELS(state, channels) {
    state.channels = channels;
  },
  ADD_PAYMENT_CHANNEL(state, channel) {
    state.channels.push(channel);
  },
  UPDATE_PAYMENT_CHANNEL(state, channel) {
    const certIndex = state.channels.findIndex(
      e => e.type === channel.type
    );
    Object.assign(state.channels[certIndex], channel);
  },
  DELETE_PAYMENT_CHANNEL(state, type) {
    const certIndex = state.channels.findIndex(u => u.type === type);
    state.channels.splice(certIndex, 1);
  }
};
